// extracted by mini-css-extract-plugin
export default {"widget":"widget_yxRH","icon":"icon_zwFJ","bg":"bg_DzGF","second":"second_vZWS","first":"first_Nu0J","third":"third_KLii","text":"text_P5DR"};